import {memo} from 'react';
import PropTypes from 'prop-types';
import {getIconClasses} from 'utilsOld/icons';

const SVGIcon = memo(({iconClass, className}) => <img className={className} src={iconClass} alt={''} />);

SVGIcon.propTypes = {
  iconClass: PropTypes.string.isRequired,
};

const SimpleIcon = ({iconLibrary, iconClass}) => {
  switch (iconLibrary) {
    case 'fontawesome':
    case 'devextreme':
      return <i className={`dx-icon ${getIconClasses({iconLibrary, iconClass})}`} />;
    case 'svg':
    case 'img':
      return <SVGIcon iconClass={iconClass} className={'dx-icon'} />;
    case 'svg_string':
      return <div className={'dx-icon d5-react-svg-icon'} dangerouslySetInnerHTML={{__html: iconClass}} />;
    default:
      return iconClass ? <i className={iconClass} /> : null;
  }
};

SimpleIcon.propTypes = {
  iconClass: PropTypes.string.isRequired,
  iconLibrary: PropTypes.string.isRequired,
};

export default SimpleIcon;
